import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Table } from 'reactstrap';
import { TextFormat, Translate, getSortState } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { ASC, DESC } from 'app/shared/util/pagination.constants';
import { overrideSortStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities } from './tariff-pricing-constraint.reducer';

export const TariffPricingConstraint = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [sortState, setSortState] = useState(
    overrideSortStateWithQueryParams(getSortState(pageLocation, 'id'), pageLocation.search),
  );

  const tariffPricingConstraintList = useAppSelector(state => state.tariffPricingConstraint.entities);
  const loading = useAppSelector(state => state.tariffPricingConstraint.loading);

  const getAllEntities = () => {
    dispatch(
      getEntities({
        sort: `${sortState.sort},${sortState.order}`,
      }),
    );
  };

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?sort=${sortState.sort},${sortState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [sortState.order, sortState.sort]);

  const sort = p => () => {
    setSortState({
      ...sortState,
      order: sortState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = sortState.sort;
    const order = sortState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="tariff-pricing-constraint-heading" data-cy="TariffPricingConstraintHeading">
        <Translate contentKey="crawlerBackendApp.tariffPricingConstraint.home.title">
          Tariff Pricing Constraints
        </Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="crawlerBackendApp.tariffPricingConstraint.home.refreshListLabel">
              Refresh List
            </Translate>
          </Button>
          <Link
            to="/tariff-pricing-constraint/new"
            className="btn btn-primary jh-create-entity"
            id="jh-create-entity"
            data-cy="entityCreateButton"
          >
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="crawlerBackendApp.tariffPricingConstraint.home.createLabel">
              Create new Tariff Pricing Constraint
            </Translate>
          </Link>
        </div>
      </h2>
      <div className="table-responsive">
        {tariffPricingConstraintList && tariffPricingConstraintList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="crawlerBackendApp.tariffPricingConstraint.id">ID</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('minPrice')}>
                  <Translate contentKey="crawlerBackendApp.tariffPricingConstraint.minPrice">Min Price</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('minPrice')} />
                </th>
                <th className="hand" onClick={sort('maxPrice')}>
                  <Translate contentKey="crawlerBackendApp.tariffPricingConstraint.maxPrice">Max Price</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('maxPrice')} />
                </th>
                <th className="hand" onClick={sort('effectiveDate')}>
                  <Translate contentKey="crawlerBackendApp.tariffPricingConstraint.effectiveDate">
                    Effective Date
                  </Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('effectiveDate')} />
                </th>
                <th>
                  <Translate contentKey="crawlerBackendApp.tariffPricingConstraint.tariff">Tariff</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {tariffPricingConstraintList.map((tariffPricingConstraint, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button
                      tag={Link}
                      to={`/tariff-pricing-constraint/${tariffPricingConstraint.id}`}
                      color="link"
                      size="sm"
                    >
                      {tariffPricingConstraint.id}
                    </Button>
                  </td>
                  <td>{tariffPricingConstraint.minPrice}</td>
                  <td>{tariffPricingConstraint.maxPrice}</td>
                  <td>
                    {tariffPricingConstraint.effectiveDate ? (
                      <TextFormat
                        type="date"
                        value={tariffPricingConstraint.effectiveDate}
                        format={APP_LOCAL_DATE_FORMAT}
                      />
                    ) : null}
                  </td>
                  <td>
                    {tariffPricingConstraint.tariff ? (
                      <Link to={`/tariff/${tariffPricingConstraint.tariff.id}`}>
                        {tariffPricingConstraint.tariff.id}
                      </Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/tariff-pricing-constraint/${tariffPricingConstraint.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/tariff-pricing-constraint/${tariffPricingConstraint.id}/edit`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/tariff-pricing-constraint/${tariffPricingConstraint.id}/delete`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="crawlerBackendApp.tariffPricingConstraint.home.notFound">
                No Tariff Pricing Constraints found
              </Translate>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default TariffPricingConstraint;
